import { BaseTool } from "./BaseTool.js";
import { isPrimaryPointer } from "./toolHelpers.js";

export class PanZoomTool extends BaseTool {
  constructor() {
    super("pan-zoom");
    this.dragStart = null;
  }

  onPointerDown(context) {
    if (!isPrimaryPointer(context)) {
      return;
    }

    context.clearPreview();
    this.dragStart = {
      screenPoint: { ...context.screenPoint },
      panX: context.viewport.panX,
      panY: context.viewport.panY
    };
  }

  onPointerMove(context) {
    if (!this.dragStart) {
      return;
    }

    context.panTo({
      x: this.dragStart.panX + context.screenPoint.x - this.dragStart.screenPoint.x,
      y: this.dragStart.panY + context.screenPoint.y - this.dragStart.screenPoint.y
    });
  }

  onPointerUp() {
    this.dragStart = null;
  }

  cancel() {
    this.dragStart = null;
  }
}
